
export enum enFrequencyType {
  DIARIO = 'D',
  MENSAL = 'M',
  ANUAL = 'Y',
}


// WEBPACK FOOTER //
// ./src/enums/enFrequencyType.ts